export default __webpack_public_path__ + "static/media/Standard34.9bc3e6b1.png";